export const initialKpiPaymentExclusion = () => ({
    listAllPaymentExclusion: [],
    currentMonthPaymentExclusion: [],
    lastMonthPaymentExclusion: [],
});

function groupByMonth(data) {
    const groupedData = {};

    data.forEach((item) => {
        const month = item.mes;
        groupedData[month] = groupedData[month] || { month, records: [] };
        groupedData[month].records.push(item);
    });

    return Object.values(groupedData);
}

export const kpiPaymentExclusion = (currentState, action) => {
    const currentDate = new Date(action.selectedDate);
    const hoje = new Date();

    // Mês selecionado ainda em curso: o card compara com o mesmo recorte de dias do
    // mês anterior, senão o mês incompleto sempre pareceria uma queda.
    const isCurrentMonth = currentDate.getMonth() === hoje.getMonth()
        && currentDate.getFullYear() === hoje.getFullYear();

    const kpiPaymentExclusion = {
        listAllPaymentExclusion: Array.isArray(action.kpiPaymentExclusion) ? action.kpiPaymentExclusion : [],
        currentMonthPaymentExclusion: [],
        lastMonthPaymentExclusion: [],
        selectedDate: new Date(action.selectedDate),
        currentDate: currentDate.getMonth() + 1,
        currentMonth: currentDate.getMonth() + 1,
        currentYear: currentDate.getFullYear(),
        currentDay: currentDate.getDate(),
        date: hoje,
        isCurrentMonth,
    };

    const groupedData = groupByMonth(kpiPaymentExclusion.listAllPaymentExclusion || []);

    kpiPaymentExclusion.currentMonthPaymentExclusion = [...(groupedData.find(e => e.month === kpiPaymentExclusion.currentMonth)?.records || [])];
    kpiPaymentExclusion.lastMonthPaymentExclusion = [...(groupedData.find(e => e.month !== kpiPaymentExclusion.currentMonth)?.records || [])];

    return {
        ...currentState,
        kpiPaymentExclusion,
    };
};
